import {useCallback, useState} from 'react';
import window from 'global/window';
import {useWindowEvent} from './useWindowEvent';

export type Hash = {
	/** current hash */
	current: string;
	currentRoute: string;
	/** old hash */
	old: string;
};

const getHashData = (currentState?: Hash): Hash => {
	const {location} = window;
	return {
		current: location.hash,
		currentRoute: location.hash.replace(/^#/, ''),
		old: currentState?.current ?? location.hash,
	};
};

export const useHash = () => {
	const [hash, setHash] = useState<Hash>(getHashData());

	useWindowEvent(
		'hashchange',
		useCallback((event) => {
			setHash((currentState) => getHashData(currentState));
		}, []),
	);

	return hash;
};

export default useHash;
